import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import { Collapse } from 'reactstrap';
import _ from 'lodash'
import singleswitch from '../../../../assets/switch.png';
import { SelectDD, ExternalDD } from '../../../../common/dropdowns';
import { empType } from '../../../../appConstants'
import DateInput from '../../../../common/DateInput'
import TabSwitch from '../../../../common/TabSwitch'
import DatePicker from "react-datepicker";
import Actions from '../../../../appFlux/action'

class EditMyExpModal extends React.Component {
    constructor(props) {
        super(props);
        var { modal, toggle, empHistory } = props
        this.state = {
            empHistory: _.cloneDeep(empHistory),
            index: empHistory.length > 0 ? 0 : undefined,
            inputCompany: "",
        }
    }

    componentWillRecieveProps(props){
        var { modal, toggle, empHistory } = props
        console.log("I AM TRIGGERED.....................")
        this.setState({
            empHistory: _.cloneDeep(empHistory),
            index: empHistory.length > 0 ? 0 : undefined,
            inputCompany: "",
        })
    }

    setIndex = (index) => {
        this.setState({ index })
    }

    setEmpHistory = (value, param) => {
        var { empHistory, index } = this.state
        empHistory[index][param] = value
        this.setState({empHistory})
    }

    addExp = () => {
        var { empHistory, inputCompany, index } = this.state
        var newExp = {
            experience: inputCompany,
            title: "",
            empType: "",
            startDate: "",
            endDate: "",
            city: "", 
            country: "",
            rolesummary: "",
            description: ""
        }
        empHistory.push(newExp)
        index = empHistory.length - 1
        this.setState({empHistory, index})
    }

    changeCurrentPosition = (value) => {
        var {index, empHistory } = this.state
        if(value === false){
            empHistory[index]["active"] = false
            this.setState({empHistory})
            return
        }
        // Handle True
        var exists = false
        empHistory.forEach((o, i) => {
            if(i !== index && o.active === true) exists = true
        })
        if(exists){
            if(window.confirm('You have another current position, would you like to end it ?')){
                empHistory.forEach((o, i) => o.active = false)
                empHistory[index]["active"] = true
                this.setState({empHistory})
            }
            else return 
        }
        else {
            empHistory[index]["active"] = true
            this.setState({empHistory})
        }
    }

    reset = () => this.setState({empHistory: _.cloneDeep(this.props.empHistory)})
    save = () => {
        Actions.setEmpHistory(this.state.empHistory)
        this.props.toggle()
    }

    render() {
        var { modal, toggle, empHistory } = this.props
        var { empHistory, inputCompany, index } = this.state
        var selectedHist = index !== undefined ? empHistory[index] : undefined
        var empTypeSelected = selectedHist ? empType.filter((o) => selectedHist.empType === o.value)[0] : undefined
        return (
            <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-850">
                <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                    <div className="modal-header">Edit Employment History</div>
                    <div className="v-align f-right" style={{ marginLeft: 'auto' }}>
                        <i className="fa fa-cog modal-close mg-r-15" ></i>
                        <i className="far fa-question-circle modal-close mg-r-15" ></i>
                        <i className="fas fa-times modal-close" onClick={toggle}></i>
                    </div>
                </div>
                <hr className="mg-r-0"></hr>
                <div className="modal-block">
                    <div className="v-align mg-b-15">
                        <div className="modal-subheader">Do you want to add work experience? (Don't Like this)</div>
                        <div className="mg-l-15"><img src={singleswitch} style={{ height: '25px' }} /> </div>
                    </div>
                    <div className="modal-subheader">Add a Company</div>
                    <div className="row">
                        <div className="col-md-6">
                            <div><input type="text" className="form-control" value={inputCompany} onChange={(e) => this.setState({ inputCompany: e.target.value })}></input></div>
                        </div>
                        <div className="col-md-6">
                            <button className="btn btn-primary" onClick={this.addExp}>
                                <i className="fas fa-plus mg-r-5"></i>Add Experience
                            <span className="button-info">4</span>
                            </button>
                        </div>
                    </div>
                </div>
                <hr className="mg-0"></hr>
                <div className="row">
                    <div className="wd-pct-23 b-r-border pd-l-25 pd-t-15 pd-r-5">
                        <ul className="nav nav-left-tabs md-tabs tabs-left">
                            <div className="col-md-12">
                                <div className="row">
                                    {empHistory.map((experience, i) => (
                                        <TabSwitch
                                            key={i}
                                            idx={i}
                                            title={experience.experience}
                                            isActive={i === index}
                                            handleOnClick={this.setIndex}
                                        />
                                    ))}
                                </div>
                            </div>
                        </ul>
                    </div>
                    <div className="wd-pct-77 pd-t-15 pd-r-25 pd-l-15 pd-b-15">
                        <div className="mg-b-5">
                            <div className="modal-subheader">Title
                                    <span className="mandatory-field">*</span>
                            </div>
                            <div><input type="text" className="form-control" value={selectedHist.title} onChange={(e) => this.setEmpHistory(e.target.value, "title")}></input></div>
                            <div className="modal-subheader">Employment Type</div>
                            <div className="mg-b-20">
                                <SelectDD data={empType} onChange={(o) => this.setEmpHistory(o.value, "empType")} selected={empTypeSelected} isClearable={false} />
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10">
                                <label>
                                    <input type="checkbox" checked={selectedHist.active} onChange={() => this.changeCurrentPosition(!selectedHist.active)}></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Current position</span>
                                </label>
                            </div>
                            <div className="row mg-b-15">
                                <div className="col-md-6">
                                    <div className="modal-subheader">Start Month/Year</div>
                                    <DatePicker
                                        selected={selectedHist.startDate}
                                        onChange={(e) => this.setEmpHistory(e, "startDate")}
                                        customInput={<DateInput />}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className="modal-subheader">End Month/Year</div>
                                    <DatePicker
                                        selected={selectedHist.active ? undefined: selectedHist.endDate}
                                        onChange={(e) => this.setEmpHistory(e, "endDate")}
                                        customInput={<DateInput disable={selectedHist.active}/>}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                </div>
                            </div>
                            <div className="row mg-b-15">
                                <div className="col-md-6">
                                    <div className="modal-subheader">City/State
                                        <span className="mandatory-field">*</span>
                                    </div>
                                    <div><input type="text" className="form-control" value={selectedHist.city} onChange={(e) => this.setEmpHistory(e.target.value, "city")}></input></div>
                                </div>
                                <div className="col-md-6">
                                    <div className="modal-subheader">Country
                                    <span className="mandatory-field">*</span>
                                    </div>
                                    <div><input type="text" className="form-control" value={selectedHist.country} onChange={(e) => this.setEmpHistory(e.target.value, "country")}></input></div>
                                </div>
                            </div>
                            <div className="modal-subheader">Role Summary</div>
                            <div className="mg-b-15">
                                <textarea className="textarea" value={selectedHist.rolesummary} onChange={(e) => this.setEmpHistory(e.target.value, "rolesummary")} style={{ marginTop: '0px', marginBottom: '0px', height: '50px' }}></textarea>
                            </div>
                            <div className="modal-subheader">Description</div>
                            <div><textarea className="textarea" value={selectedHist.description} onChange={(e) => this.setEmpHistory(e.target.value, "description")} style={{ marginTop: '0px', marginBottom: '0px', height: '153px' }}></textarea></div>
                        </div>
                    </div>
                </div>
                <hr className="mg-0 "></hr>
                <div className="pd-20 box-shadow-top">
                    <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>
                    <button className="btn btn-primary-lite f-right mg-r-15" onClick={this.save}>Save</button>
                    <button className="btn btn-success-lite mg-r-15 f-right" onClick={this.reset}>Reset</button>
                </div>
            </Modal>
        )
    }
}
export default EditMyExpModal;